import { useSelector } from 'react-redux';
import {
  selectActiveServiceId,
  selectCompetitors,
  selectServiceById,
} from '../../../../../../../reducers/v2/promotion/selectors';
import { selectCurrentBet } from '../../../../../../../selectors/auction';
import { EServiceId } from '../../../../../../../types/reducers/publishTerms';
import { getCompetitorsLevel, getCompetitorsList, mapCompetitorsToPromotionsList } from './utils';
import { ICompetitors } from './types';
import { selectCompetitorsExperiment } from '../../../../../../../selectors/experiments';

export const useCompetitors = (): ICompetitors => {
  const isEnabled = useSelector(selectCompetitorsExperiment);
  const competitorsState = useSelector(selectCompetitors);
  const selectedService = useSelector(selectActiveServiceId);
  const auctionBet = useSelector(selectCurrentBet);
  const selectService = selectServiceById(EServiceId.top);
  const topService = useSelector(selectService);

  const isBetMoreThanTop = topService ? auctionBet > topService.price : false;

  const competitors = getCompetitorsList(competitorsState, isBetMoreThanTop);
  const promotions = mapCompetitorsToPromotionsList(competitors, selectedService, isBetMoreThanTop);
  const level = getCompetitorsLevel(promotions);

  return {
    promotions: isEnabled ? promotions : [],
    level: isEnabled ? level : null,
  };
};
